import React, { Component } from "react";
import {
  Typography,
  Row,
  Col,
  Select,
  message,
  Alert,
  List,
  Tag,
  Radio,
  Divider,
} from "antd";
import { CarOutlined, InboxOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import axios from "axios";
import {
  ModalItem,
  ButtonItem,
  DatePickerItem,
  FormItem,
  Form,
  TextAreaItem,
  InputNumberItem,
} from "../../../../Components/Items";
import moment from "moment";

const { Text } = Typography;
const { Option } = Select;

class ModalProgramarRecoleccion extends Component {
  state = {
    cargando: false,
    configPaqueteria: null,

    // Formulario
    fecha: null,
    horaInicio: null,
    horaFin: null,
    instrucciones: null,

    // Modos y Totales
    esModoManual: false,
    pesoTotal: null,
    cantidadCajas: null,
    pesoCalculado: null,
    cajasCalculadas: null,

    // Datos de los paquetes a recolectar
    listaPaquetes: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.prepararDatos();
      this.obtenerConfigPaqueteria();
    }
    if (!this.props.visible && prevProps.visible) {
      this.setState({
        fecha: null,
        horaInicio: null,
        horaFin: null,
        instrucciones: null,
        configPaqueteria: null,
        esModoManual: false,
        pesoTotal: null,
        cantidadCajas: null,
        pesoCalculado: null,
        cajasCalculadas: null,
        listaPaquetes: [],
      });
    }
  }

  prepararDatos = () => {
    const { carrier: paqueteria, origenKey, ventasLocal } = this.props;
    let lista = [];

    let pesoTotalCalculado = 0;
    let cajasTotalesCalculadas = 0;
    const esDropshipping = origenKey === "dropshipping_urrea";

    if (ventasLocal) {
      ventasLocal.forEach((venta) => {
        const envioValido = venta.cotizacionesEnvioOnline?.find(
          (envio) =>
            envio.origen === origenKey &&
            envio.carrier === paqueteria &&
            envio.estadoPaquete === 2 &&
            envio.trackingNumber,
        );

        if (envioValido) {
          let pesoOrden = 0;
          let cajasOrden = 0;

          if (
            envioValido.paquetesArmados &&
            envioValido.paquetesArmados.length > 0
          ) {
            envioValido.paquetesArmados.forEach((paq) => {
              pesoOrden += Number(paq.peso) * Number(paq.cantidadCajas);
              cajasOrden += Number(paq.cantidadCajas);
            });
          } else {
            cajasOrden = 1;
            if (venta.insumos && venta.insumos.length > 0) {
              venta.insumos.forEach((insumo) => {
                if (!!insumo.dropshipping === esDropshipping) {
                  const pesoItem = insumo.pesoEnKGM
                    ? Number(insumo.pesoEnKGM)
                    : 1;
                  pesoOrden += pesoItem * insumo.cantidad;
                }
              });
            } else {
              pesoOrden = 1;
            }
          }

          pesoTotalCalculado += pesoOrden;
          cajasTotalesCalculadas += cajasOrden;

          lista.push({
            folio: venta.serieNumero,
            tracking: envioValido.trackingNumber,
            cliente:
              venta.clienteOnline?.nombre +
              " " +
              venta.clienteOnline?.apellidoPaterno,
            peso: Number(pesoOrden.toFixed(2)),
            cajas: cajasOrden,
          });
        }
      });
    }

    const pesoFinal = Number(pesoTotalCalculado.toFixed(2)) || 1;
    const cajasFinales = cajasTotalesCalculadas || 1;

    this.setState({
      listaPaquetes: lista,
      cajasCalculadas: cajasFinales,
      pesoCalculado: pesoFinal,
      cantidadCajas: cajasFinales,
      pesoTotal: pesoFinal,
    });
  };

  obtenerConfigPaqueteria = () => {
    const { carrier: paqueteria, empresaId, headersToken } = this.props;
    this.setState({ cargando: true });

    axios
      .post(
        "paqueteria/obtenerPaqueteria",
        { empresaId, nombre: paqueteria },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 || res.data.success === true) {
          const config = res.data.data;
          this.setState({
            configPaqueteria: config,
            horaInicio: config.horaInicioRecoleccion,
            horaFin: config.horaFinRecoleccion,
            cargando: false,
          });
        } else {
          this.setState({ cargando: false });
        }
      })
      .catch(() => this.setState({ cargando: false }));
  };

  deshabilitarFecha = (fechaActual) => {
    if (!fechaActual) return false;
    const { configPaqueteria } = this.state;
    const hoy = moment().startOf("day");

    if (fechaActual < hoy) return true;

    if (configPaqueteria && fechaActual.isSame(hoy, "day")) {
      const horaActual = moment().hour();
      if (
        !configPaqueteria.recoleccionMismoDia ||
        horaActual >= configPaqueteria.horaLimiteRecoleccionMismoDia
      ) {
        return true;
      }
    }
    return false;
  };

  cambiarModoManual = (e) => {
    const esManual = e.target.value;
    this.setState({ esModoManual: esManual });

    if (!esManual) {
      this.setState({
        pesoTotal: this.state.pesoCalculado,
        cantidadCajas: this.state.cajasCalculadas,
      });
    }
  };

  programar = () => {
    const {
      carrier: paqueteria,
      origenKey,
      empresaId,
      headersToken,
      onSuccess,
    } = this.props;
    const {
      fecha,
      horaInicio,
      horaFin,
      instrucciones,
      pesoTotal,
      cantidadCajas,
      listaPaquetes,
      configPaqueteria,
    } = this.state;

    if (listaPaquetes.length === 0)
      return message.warning("No hay paquetes válidos para recolectar.");
    if (!fecha) return message.warning("Selecciona una fecha de recolección.");
    if (horaInicio === null || horaFin === null)
      return message.warning("Selecciona un rango de horas válido.");
    if (horaInicio >= horaFin)
      return message.warning(
        "La hora de inicio debe ser menor a la hora de fin.",
      );
    if (!pesoTotal || !cantidadCajas)
      return message.warning("Ingresa el peso y la cantidad de paquetes.");

    if (configPaqueteria && configPaqueteria.limitePesoCaja) {
      const pesoPromedioPorCaja = pesoTotal / cantidadCajas;
      if (pesoPromedioPorCaja > configPaqueteria.limitePesoCaja) {
        return message.warning(
          `El peso promedio por caja (${pesoPromedioPorCaja.toFixed(2)} KG) excede el límite de ${configPaqueteria.limitePesoCaja} KG permitido por ${paqueteria.toUpperCase()}.`,
        );
      }
    }

    this.setState({ cargando: true });

    axios
      .post(
        "ventasEcommerce/programarRecoleccion",
        {
          empresaId,
          origenKey,
          carrier: paqueteria,
          date: fecha.format("YYYY-MM-DD"),
          timeFrom: horaInicio,
          timeTo: horaFin,
          instructions: instrucciones || "Pasar a recoger a bodega",
          totalWeight: pesoTotal,
          totalPackages: cantidadCajas,
        },
        { headers: headersToken },
      )
      .then((res) => {
        this.setState({ cargando: false });
        if (res.data.success === 2) {
          message.success(res.data.message);
          onSuccess();
        } else {
          message.warning(res.data.message);
        }
      })
      .catch(() => {
        this.setState({ cargando: false });
        message.error("Error al conectar con el servidor.");
      });
  };

  render() {
    const { visible, onCancel, carrier } = this.props;
    const {
      cargando,
      configPaqueteria,
      listaPaquetes,
      horaInicio,
      horaFin,
      pesoTotal,
      cantidadCajas,
      esModoManual,
      instrucciones,
    } = this.state;

    const nombrePaqueteria = carrier?.toUpperCase() || "";

    const opcionesHoraInicio = [];
    const opcionesHoraFin = [];

    const horaInicioConfig = configPaqueteria
      ? configPaqueteria.horaInicioRecoleccion
      : 9;
    const horaFinConfig = configPaqueteria
      ? configPaqueteria.horaFinRecoleccion
      : 18;

    for (let i = horaInicioConfig; i <= horaFinConfig - 1; i++) {
      if (horaFin === null || i < horaFin) {
        opcionesHoraInicio.push(
          <Option key={`inicio-${i}`} value={i}>
            {moment({ hour: i }).format("hh:mm A")}
          </Option>,
        );
      }
    }

    for (let i = horaInicioConfig + 1; i <= horaFinConfig; i++) {
      if (horaInicio === null || i > horaInicio) {
        opcionesHoraFin.push(
          <Option key={`fin-${i}`} value={i}>
            {moment({ hour: i }).format("hh:mm A")}
          </Option>,
        );
      }
    }

    return (
      <ModalItem
        title={
          <span>
            <CarOutlined /> Programar Recolección ({nombrePaqueteria})
          </span>
        }
        visible={visible}
        onCancel={onCancel}
        width={650}
        spinning={cargando}
      >
        <Alert
          message="Desglose de Paquetes"
          description="A continuación se muestra el peso basándonos en cómo empaquetaste las ventas."
          type="info"
          showIcon
          style={{ marginBottom: 15, marginTop: 15 }}
        />

        <List
          size="small"
          bordered
          style={{
            marginBottom: 15,
            maxHeight: "200px",
            overflowY: "auto",
            backgroundColor: "#fff",
          }}
          dataSource={listaPaquetes}
          renderItem={(paquete) => (
            <List.Item>
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    <Text strong>{paquete.folio}</Text> - {paquete.cliente}
                  </span>
                  <Tag color="blue">{paquete.tracking}</Tag>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#8c8c8c",
                    marginTop: "4px",
                  }}
                >
                  <InboxOutlined style={{ marginRight: 4 }} /> Cajas:{" "}
                  {paquete.cajas}
                  <Divider type="vertical" />
                  Peso Declarado: {paquete.peso} KG
                </div>
              </div>
            </List.Item>
          )}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 15,
            padding: "10px",
            background: "#f5f5f5",
            borderRadius: "8px",
          }}
        >
          <Text strong>Modo de captura:</Text>
          <Radio.Group
            value={esModoManual}
            onChange={this.cambiarModoManual}
            buttonStyle="solid"
          >
            <Radio.Button value={false}>Automático</Radio.Button>
            <Radio.Button value={true}>Manual</Radio.Button>
          </Radio.Group>
        </div>

        <Form layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <FormItem
                label="Total Cajas (Recolección)"
                required
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 8 }}
              >
                <InputNumberItem
                  min={1}
                  style={{ width: "100%" }}
                  value={cantidadCajas}
                  onChange={(valor) => this.setState({ cantidadCajas: valor })}
                  disabled={!esModoManual}
                />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                label="Peso Total (KG)"
                required
                labelCol={{ span: 12 }}
                wrapperCol={{ span: 12 }}
              >
                <InputNumberItem
                  min={0.1}
                  step={0.1}
                  style={{ width: "100%" }}
                  value={pesoTotal}
                  onChange={(valor) => this.setState({ pesoTotal: valor })}
                  disabled={!esModoManual}
                />
              </FormItem>
            </Col>

            <Col span={24}>
              <FormItem label="Fecha de recolección" required>
                <DatePickerItem
                  style={{ width: "100%" }}
                  disabledDate={this.deshabilitarFecha}
                  value={this.state.fecha}
                  onChange={(nuevaFecha) =>
                    this.setState({ fecha: nuevaFecha })
                  }
                />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                label="Hora Inicio"
                required
                labelCol={{ span: 12 }}
                wrapperCol={{ span: 12 }}
              >
                <Select
                  value={horaInicio}
                  onChange={(valor) => this.setState({ horaInicio: valor })}
                >
                  {opcionesHoraInicio}
                </Select>
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                label="Hora Fin (Límite)"
                required
                labelCol={{ span: 12 }}
                wrapperCol={{ span: 12 }}
              >
                <Select
                  value={horaFin}
                  onChange={(valor) => this.setState({ horaFin: valor })}
                >
                  {opcionesHoraFin}
                </Select>
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem label="Instrucciones especiales (Opcional)" labelCol={{ span: 12 }}
                wrapperCol={{ span: 12 }}>
                <TextAreaItem
                  rows={2}
                  placeholder="Ej. Tocar el timbre rojo, preguntar en caseta..."
                  value={instrucciones || ""}
                  onChange={(e) =>
                    this.setState({ instrucciones: e.target.value })
                  }
                />
              </FormItem>
            </Col>
          </Row>

          <div style={{ textAlign: "right", marginTop: 10 }}>
            <ButtonItem onClick={onCancel} blanco style={{ marginRight: 8 }}>
              Cancelar
            </ButtonItem>
            <ButtonItem
              type="primary"
              verde
              onClick={this.programar}
              disabled={listaPaquetes.length === 0}
            >
              Agendar Recolección
            </ButtonItem>
          </div>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalProgramarRecoleccion);
